module.exports = __webpack_public_path__ + "static/media/Ayla_N.2e738882.jpg";